const CryptoJS = require('crypto-js');
const lambdaLink = require('../config/lambda.json');

const encryptedAPI = () => {
    
  const apiKey = lambdaLink.API_Key;
  const passphrase = lambdaLink.passPhrase;
  return CryptoJS.AES.encrypt(apiKey, passphrase).toString();
}
module.exports = encryptedAPI;